import { getConsumerMailbox } from '../services/getConsumerMailbox';
import { resetConsumerDefaultFromStore } from '../actions/defaultFrom/resetConsumerDefaultFromStore';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';

export async function loadDefaultAddressOption(): Promise<void> {
    if (isConsumer()) {
        let response = await getConsumerMailbox();
        resetConsumerDefaultFromStore(response.ErrorMessage ? null : response.Options);
    } else {
        Promise.resolve();
    }
}
